import React, { FC } from "react";
import { BhiDrawer, SelectOption } from "src/UIKit";
import { FormView } from "src/components/FormPart/FormView";
import { Application } from "src/modules/applications/types";
import { CreateAdminPlanFormDrawerController } from "../../controllers";
import { CreateAdminPlanForm } from "./CreateAdminPlanForm";

interface CreateAdminPlanFormDrawerProps extends CreateAdminPlanFormDrawerController {
  applicationOptions: SelectOption<string, string, Application>[];
}

export const CreateAdminPlanFormDrawer: FC<CreateAdminPlanFormDrawerProps> = (props) => {
  const { isOpen, close, initFormData, applicationOptions, submit } = props;
  return (
    <BhiDrawer isOpen={isOpen} onClose={close} title={initFormData?.id ? "Update Plan" : "Create Plan"}>
      {initFormData && (
        <FormView
          formData={initFormData}
          component={CreateAdminPlanForm}
          componentProps={{ applicationOptions }}
          onSubmit={(full, dirty) => submit(full, dirty)}
        />
      )}
    </BhiDrawer>
  );
};
